<template>
  <div class="help">
    <Banner :top="0" />
    <main class="center">
      <ul>
        <li class="item">
          <h1 class="item_h1">
            常见FAQ-Spark
          </h1>
          <a @click="toDetail(1)">一般常见FAQ-Spark音箱</a>
        </li>
        <li class="item">
          <h1 class="item_h1">
            产品信息
          </h1>
          <a @click="toDetail(2)">Spark 内置效果器</a>
          <a @click="toDetail(3)">Spark 内置音箱列表</a>
        </li>
        <li class="item">
          <h1 class="item_h1">
            使用方法
          </h1>
          <a @click="toDetail(4)">如何导入Apple Music的播放列表并使用实时显示和弦功能？</a>
          <a @click="toDetail(5)">
            预置音色管理（保存到硬件 / 音色云下载和上传）
          </a>
          <a @click="toDetail(6)">
            如何通过蓝牙方式将 Spark 音箱与iPhone/iPad 配对？
          </a>
          <a @click="toDetail(7)">如何通过蓝牙方式将 Spark 音箱与安卓设备配对？</a>
          <a @click="toDetail(8)">
            如何恢复出厂设置？
          </a>
          <a @click="toDetail(9)">如何开始智能模拟乐队伴奏？</a>
        </li>
        <li class="item">
          <h1 class="item_h1">
            固件
          </h1>
          <a @click="toDetail(10)">如何升级Spark音箱的固件？</a>
        </li>
        <li class="item">
          <h1 class="item_h1">
            故障排除
          </h1>
          <a @click="toDetail(11)">蓝牙或USB回放没有声音</a>
          <a @click="toDetail(12)">在使用高增益音色的时候如何消除噪声？</a>
        </li>
      </ul>
    </main>
    <div class="code_box">
      <div class="code_text">
        <h2>
          联系客服
        </h2>
        <p>微信搜索并关注 PositiveGrid 公众号，回复“我要入群”加入官方微信群，了解更多最新资讯。如有任何问题，请于Positive Grid微信公众号留言，我们会尽快给予回复。谢谢。</p>
      </div>
      <div class="code_img">
        <img
          src="~@/assets/help/code.jpg"
          alt=""
        >
        <p>微信搜索并关注PositiveGrid回复“我要入群”</p>
      </div>
    </div>
    <FooterCommon />
  </div>
</template>
<script>
import Banner from '@/components/banner'
import FooterCommon from '@/components/footer-common'

export default {
  components: {
    Banner,
    FooterCommon
  },
  data () {
    return {}
  },
  methods: {
    toDetail (num) {
      this.$router.push({
        path: '/help-center-detail',
        query: {
          id: num
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.help {
    min-height: 300px;
    background: #fff;
    margin-top: 54px;
    font-family: PingFangSC-Regular, Roboto, Noto Sans SC, sans-serif;

    .center {
        padding: 64px 72px;
        ul {
            .item {
                margin-bottom: 64px;
                .item_h1 {
                    font-style: normal;
                    font-weight: 900;
                    font-size: 32px;
                    color: #282828;
                    padding-bottom: 25px;
                    border-bottom: 1px solid #b8b8b8;
                }
                a {
                    display: block;
                    margin-top: 20px;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 18px;
                    color: #e02020;
                    cursor: pointer;
                    text-align: justify;
                    justify-content: space-between;
                }
            }
        }
        @media (max-width: 768px) {
            padding: 53px 48px;
            ul {
                .item {
                    margin-bottom: 64px;
                    .item_h1 {
                        font-size: 24px;
                    }
                    a {
                        font-size: 16px;
                    }
                }
            }
        }
        @media (max-width: 376px) {
            padding: 26px 40px;
        }
    }
    .code_box {
        padding: 64px 72px;
        background: #f9cb7c;
        display: flex;
        justify-content: center;

        .code_text {
            flex: 1;
            color: #101010;
            margin-right: 48px;
            min-width: 304px;
            h2 {
                font-style: normal;
                font-weight: 900;
                font-size: 24px;
                margin-bottom: 24px;
            }
            p {
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                text-align: justify;
                justify-content: space-between;
            }
        }
        .code_img {
            width: 160px;
            // height: 204px;
            font-size: 12px;
            color: #333;
            img {
                width: 160px;
                height: 160px;
            }
            p {
                margin-top: 10px;
                text-align: center;
                display: flex;
            }
        }
        @media (max-width: 768px) {
            flex-wrap: wrap;
            .code_text {
                margin-right: 0;
                margin-bottom: 24px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/helpCenter/help-center.vue